<template>
  <modal
    :show="true"
    :large="true"
    v-on:close="closeModal"
    :enable-event="!alertIsOpen"
  >
    <div slot="title">
      <h4>Edit Report</h4>
    </div>
    <div class="row">
      <div class="col-xl-12">
        <div class="form-horizontal">
          <inputbox
            v-model="form.incident_number"
            name="incident_number"
            label="Incident Number"
          ></inputbox>

          <inputbox
            v-model="form.officer_name"
            name="officer_name"
            label="Officer Name / No"
          ></inputbox>

          <inputbox
            v-model="form.telephone"
            name="telephone"
            label="Telephone"
          ></inputbox>

          <toggleswitch
            :labels="true"
            name="officer_attended"
            label="Did the officer attend the incident?"
            v-model="form.officer_attended"
          ></toggleswitch>

          <div class="form-group">
            <label for="incident_reported_at" class="col-lg-2 control-label"
              >Incident Reported:</label
            >
            <div class="col-lg-10">
              <datepicker
                format="dd/MM/yyyy"
                :value="form.incident_reported_at"
                v-on:selected="setIncidentReportedDate"
                input-class="form-control"
                placeholder="dd/mm/yyyy"
              ></datepicker>
            </div>
          </div>

          <div class="form-group">
            <label for="report_requested_at" class="col-lg-2 control-label"
              >Report Requested:</label
            >
            <div class="col-lg-10">
              <datepicker
                format="dd/MM/yyyy"
                :value="form.report_requested_at"
                v-on:selected="setReportRequestedDate"
                input-class="form-control"
                placeholder="dd/mm/yyyy"
              ></datepicker>
            </div>
          </div>

          <div class="form-group">
            <label for="report_received_at" class="col-lg-2 control-label"
              >Report Received:</label
            >
            <div class="col-lg-10">
              <datepicker
                format="dd/MM/yyyy"
                :value="form.report_received_at"
                v-on:selected="setReportReceivedDate"
                input-class="form-control"
                placeholder="dd/mm/yyyy"
              ></datepicker>
            </div>
          </div>

          <toggleswitch
            :labels="true"
            name="client_breathalysed"
            label="Was the Client Breathalysed?"
            v-model="form.client_breathalysed"
          ></toggleswitch>

          <toggleswitch
            :labels="true"
            name="third_party_breathalysed"
            label="Was the TP Breathalysed?"
            v-model="form.third_party_breathalysed"
          ></toggleswitch>
        </div>
      </div>
    </div>
    <div slot="footer">
      <button
        class="btn btn-danger float-left"
        type="button"
        v-on:click="deleteReport"
      >
        Delete
      </button>
      <button type="button" v-on:click="closeModal" class="btn btn-danger">
        Close
      </button>
      <button v-on:click="updateReport" type="button" class="btn btn-primary">
        Update Report
      </button>
    </div>
  </modal>
</template>
<script>
export default {
  props: {
    incident: {
      type: String,
      required: true
    },

    report: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      alertIsOpen: false,
      form: new window.Form(
        {
          incident_number: this.report.incident_number,
          officer_name: this.report.officer_name,
          telephone: this.report.telephone,
          officer_attended: this.report.officer_attended,
          incident_reported_at: window.DateManager.format(
            this.report.incident_reported_at
          ),
          report_requested_at: window.DateManager.format(
            this.report.report_requested_at
          ),
          report_received_at: window.DateManager.format(
            this.report.report_received_at
          ),
          client_breathalysed: this.report.client_breathalysed,
          third_party_breathalysed: this.report.third_party_breathalysed
        },
        false
      )
    };
  },

  methods: {
    closeModal() {
      this.alertIsOpen = true;

      window
        .swal({
          title: 'Are you sure?',
          text: 'You will lose any unsaved changes',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes'
        })
        .then(confirmed => {
          if (confirmed) {
            this.$emit('close');
          }
        })
        .catch(error => {
          setTimeout(() => {
            this.alertIsOpen = false;
          }, 500);
        });
    },

    deleteReport() {
      this.alertIsOpen = true;

      window
        .swal({
          title: 'Are you sure?',
          text: 'You cannot undo this',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes'
        })
        .then(confirmed => {
          if (confirmed) {
            window.Ajax.delete(
              '/incidents/' +
                this.incident +
                '/police-reports/' +
                this.report.identifier
            )
              .then(response => {
                this.$emit('deleted', this.report);
              })
              .catch(error => {
                window.toastify.error(
                  'Error',
                  'Sorry, there was an issue deleting the report.'
                );
              });
          }
        })
        .catch(error => {
          setTimeout(() => {
            this.alertIsOpen = false;
          }, 500);
        });
    },

    updateReport() {
      this.form
        .put(
          '/incidents/' +
            this.incident +
            '/police-reports/' +
            this.report.identifier
        )
        .then(response => {
          this.$emit('updated', response);
        })
        .catch(response => {
          window.toastify.error('Please complete the required fields');
        });
    },

    setIncidentReportedDate(value) {
      this.form.incident_reported_at = value;
    },

    setReportRequestedDate(value) {
      this.form.report_requested_at = value;
    },

    setReportReceivedDate(value) {
      this.form.report_received_at = value;
    }
  }
};
</script>
